<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file eventModule.vue is part of event_pass_client.dev.               -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - eventModule.vue can not be copied and/or distributed                      -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->
<template>
    <div :class="`module-items--${layout.type}`" v-if="items.length > 0">
        <!--image cards-->
        <div v-if="layout.type === 'image_card'">
            <div v-for="items in groupedItemsToRows" class="row">
                <div v-for="item in items" class="module-items--image_card--item" :class="createColumns()">
                    <a v-if="layout.actions.active_click" :href="createLink(item[path.data])">
                        <div v-if="layout.type === 'image_card'">
                            <div class="card card-image"
                                    :style="{'background-image': 'url('+item[path.data].images[0]+')'}"
                            >
                                <!-- Content -->
                                <div class="text-white text-center d-flex align-items-center rgba-stylish-strong py-5 px-4">
                                    <div class="w-100">
                                        <h5 class="h3-responsive pink-text">
                                            <i v-if="!tag.tag_data.icon.is_font_awesome"
                                                    :class="tag.tag_data.icon.font"
                                            ></i>
                                            <span v-else="" :class="tag.tag_data.icon.font"></span>
                                            {{tag.tag_data.lang[lang].title}}</h5>
                                        <h3 class="card-title pt-2">
                                            <strong>{{item[path.data].lang.en_GB.title}}</strong>
                                        </h3>
                                        <div v-if="(layout.show.description.short === true)"
                                                class="module-items--description-short"
                                        >
                                            {{truncate(item[path.data].lang.en_GB.description.short, truncate_count)}}
                                        </div>
                                        <div v-if="(layout.show.description.long === true)"
                                                class="module-items--description-long"
                                        >
                                            {{item[path.data].lang.en_GB.description.long}}
                                        </div>

                                        <a v-if="layout.show.more.button === true" class="btn btn-pink"
                                                :href="createLink(item[path.data])"
                                        ><i
                                                class="icomoon-ticket left"
                                        ></i> {{layout.show.more.text}}</a>
                                    </div>
                                </div>
                                <!-- Content -->
                            </div>
                        </div>
                        <div v-else>

                        </div>
                    </a>
                    <div v-else>
                        <div v-if="layout.type === 'image_card'">
                            <div class="card card-image"
                                    :style="{'background-image': 'url('+item[path.data].images[0]+')'}"
                            >
                                <!-- Content -->
                                <div class="text-white text-center d-flex align-items-center rgba-stylish-strong py-5 px-4">
                                    <div class="w-100">
                                        <h5 class="h3-responsive pink-text">
                                            <i v-if="!tag.tag_data.icon.is_font_awesome"
                                                    :class="tag.tag_data.icon.font"
                                            ></i>
                                            <span v-else="" :class="tag.tag_data.icon.font"></span>
                                            {{tag.tag_data.lang[lang].title}}</h5>
                                        <h3 class="card-title pt-2">
                                            <strong>{{item[path.data].lang.en_GB.title}}</strong>
                                        </h3>
                                        <div v-if="(layout.show.description.short === true)"
                                                class="module-items--description-short"
                                        >
                                            {{truncate(item[path.data].lang.en_GB.description.short, truncate_count)}}
                                        </div>
                                        <div v-if="(layout.show.description.long === true)"
                                                class="module-items--description-long"
                                        >
                                            {{item[path.data].lang.en_GB.description.long}}
                                        </div>

                                        <a v-if="layout.show.more.button === true" class="btn btn-pink"
                                                :href="createLink(item[path.data])"
                                        ><i
                                                class="icomoon-ticket left"
                                        ></i> {{layout.show.more.text}}</a>
                                    </div>
                                </div>
                                <!-- Content -->
                            </div>
                        </div>
                        <div v-else>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
                v-if="layout.type === 'list'"
                class=""
                :class="`module-items--${layout.type}-item`"
        >
            <!--<h1>hi!</h1>-->

            <calendar-list
                    data-vue-element="calendar-list"
                    :use_title_slot="true"
                    :filter_list="true"
                    :base_url="base_url"
                    :list_classes="base_classes"
                    :items="items"
                    :layout="layout"
                    :path="path" :msg="msg"
            >
                <template slot="title">
                    <h1 class="h6 m-0" :class="`module-items--${layout.type}--title ${base_classes}`">
                        <a class="d-flex text-info  justify-content-between align-items-center " :href="event_url">
                            <i class="fa mr-1" :class="'icon-category-'+category_slug"></i>
                            <bold-words
                                    :cls="titleClasses"
                                    :word="titleStyle"
                                    class="d-flex justify-content-start align-items-center"
                            />

                        </a>
                    </h1>
                </template>
            </calendar-list>
        </div>
    </div>
</template>

<script>
	import axios from 'axios';
	import {BOOSTRAP_COLUMN_GRID} from '../../../config/config';
	import {truncate} from '../../../../../../app/Shared/Resources/Assets/js/helpers/format.string';
	import {getDate, getTime} from '../../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
	import {createUrlFromData} from '../../../tools/format.data_url';
	import _ from 'lodash' ;
	import {_ as underscore} from 'underscore' ;
	import {mergeObjectDeep} from '../../../tools/objects.arrays';

	Vue.component('bold-words', require('../../../../../../app/Shared/Resources/Assets/js/components/BoldWords'));
	Vue.component('calendar-list', require('../../lists/CalendarList'));
	/**
	 * Usually part of the pages manager mules
	 */
	export default {
		computed: {
			/**
			 * Returns a nested array: e.g
			 *  [[article, article, article], [article, article, article], ...]
			 */
			groupedItemsToRows() {

				return _.chunk(this.items, this.layout.columns.number_of);
			}
		},
		components: {axios},
		props: ['content'],
		watch: {
			items(val) {
				// console.log('items', 'val',val);
				if (this.loaded) {
					this.showHideModule(val);

				}

			}
		},
		created() {

		},
		mounted() {
			this.base_url = document.getElementsByTagName("body")[0].getAttribute("data-app");

			if ('base_classes' in this.content) {
				this.base_classes = this.content.base_classes;
			}
			this.url = this.content.url;
			this.params = this.content.params;
			this.path = this.content.path;
			this.title = this.content.title;
			this.titleStyle.text = this.title;
			if (this.content.hasOwnProperty('lang')) {
				this.lang = this.content.lang;
			}
			if (this.content.hasOwnProperty('event_url')) {
				this.event_url = this.content.event_url;
			}
			if (this.content.hasOwnProperty('category_slug')) {
				this.category_slug = this.content.category_slug;
			}
			if (this.content.hasOwnProperty('hide_if_empty_id')) {
				this.hide_if_empty_id = this.content.hide_if_empty_id;
			}
// console.log('title',title);
			this.layout = mergeObjectDeep(this.layout, this.content.layout);

			if (this.layout.columns) {
				this.layout.columns.width = BOOSTRAP_COLUMN_GRID / this.content.layout.columns.number_of;
				this.truncate_count = this.layout.columns.number_of * 20;
			}
			// console.log('this.url',this.url);
			// console.log('this.path', this.path);
			this.readEvents();

		},
		data() {
			return {
				titleClasses:{
					first:'mr-1',
					last:''
				},
				loaded: false,
				category_slug: 'generic',
				hide_if_empty_id: String,
				base_classes: '',
				base_url: '',
				event_url: '/',
				msg: {
					no_events: 'No upcoming events'
				},
				titleStyle: {
					text: '',
					params: {
						bold: {
							first: true
						}
					}
				},
				layout: {

					type: 'list',
					actions: {
						active_click: false,
					},
					show: {
						description: {
							long: false,
							short: true
						},
						more: {
							button: true,
							text: 'not set'
						}
					},
					columns: {
						number_of: null,
						width: null
					}
				},

				title: '',
				lang: 'en_GB',
				params: {},
				url: '',
				items: [],
				path: {},
				truncate_count: 20,
				tag: {},
			};
		},
		methods: {
			showHideModule(val) {
				let elm = $(`#${this.hide_if_empty_id}`);
// console.log('showHideModule', 'val',val);
				// console.log('items', 'elm', elm, 'val.length', val.length, 'this.hide_if_empty_id', this.hide_if_empty_id);
				if (this.hide_if_empty_id !== '') {

					if (val.length <= 0) {
						// elm.fadeOut();
						// this.destroy();
						var vm = this.$mount(`#${this.hide_if_empty_id}`);
						// console.log('showHideModule', 'this.hide_if_empty_id', this.hide_if_empty_id, vm);
						// var vm = this;
						// elm.$destroy();
						let parent = elm.parent().parent();

						vm.$destroy();
						elm.remove();

						// test for others
						// let hasChildren = parent.find('.category_filtered');
						// // .children('.category_filtered');
						// if(hasChildren.length <= 1){
						// 	// set the wrapper for the parent first
						// 	let merge_neighbour = $('#upsell-wrapper');
						//     if(merge_neighbour.length > 0){
						//         if(parent.hasClass('container-fluid')){
						//             parent.removeClass('container-fluid').addClass(['col-12','col-md-6']);
						//             // console.log('showHideModule', 'hasChildren',hasChildren);
						//             hasChildren.attr('class','category_filtered col-12')
						//         }
						//         if(merge_neighbour.hasClass('container-fluid')){
						//             merge_neighbour.removeClass('container-fluid').addClass(['col-12','col-md-6'])
						//         }
						//     }
						// }

						// console.log('showHideModule', 'parent', parent);
						// console.log('showHideModule', 'hasChildren', hasChildren);
					}
					else {
						elm.fadeIn();
					}
				}
			},
			readTitle(item) {
				// console.log('obj',obj);
				let title = item[this.path.data].lang.en_GB.title;
				// console.log('title', title);
				return title;
			},
			log(str, obj) {
				// console.log(str, obj);
			},
			createColumns() {
				if (this.layout.columns.width !== null) {
					return `col-12 col-sm-6 col-md-${this.layout.columns.width + 1} col-lg-${this.layout.columns.width}`;
				}
				return 'test-wrapper';
			},

			/**
			 *
			 * creates link provided from the route
			 * @param item
			 */
			createLink(item) {
				// console.log('item', item);
				// console.log('this.base_url', this.base_url);
				// console.log('createLink(item) this.path.route', this.path.route);

				let structure = this.path.route.structure.split('.');

				let routeUrl = this.path.route.name.split('/');
				let first = routeUrl.shift();

				// console.log(this.path.route.structure, 'structure', structure);
				// console.log(this.path.route.name, 'routeUrl', routeUrl);

				for (let i = 0; i < structure.length; i++) {
					let route_element = structure[i];

					if (route_element + '_expr' == routeUrl[i]) {
						routeUrl[i] = route_element + '--added';

						switch (route_element) {
							case 'date':
								routeUrl[i] = this.getDate(item.start_date, 'url_date');
								break;

							case 'slug':
								routeUrl[i] = item.slug;
								break;
						}
					}

				}

				// console.log('routeUrl', routeUrl);
				return this.base_url + '/' + routeUrl.join('/').toLowerCase();
				// return createUrlFromData(table_data, this.path.route);

			},
			truncate(str, length) {
				return truncate(str, length);
			},
			getDate(string, format) {
				return getDate(string, format);
			},
			getTime(string) {
				return getTime(string);
			},
			readEvents() {
				let _this = this;
				_this.loaded = false;
				axios({
					method: 'get',
					url: _this.url,
					params: this.params

				}).then((response) => {
					if (response.status !== 200) {
						console.error('No response');
					}
					// console.log('response.data',response.data);
					_this.items = response.data[_this.path.table];
					if (_this.layout.type === 'image_card') {
						console.log('_this.items', _this.items);
					}
					else {

					}
					_this.tag = response.data;
					_this.loaded = true;
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/modules/eventModule.vue